import { useMutation } from "@tanstack/react-query"

import i18n from "@/i18n/config"
import { AddToCartRequest, AddToCartResponse } from "@/types/Cart"

import { publicApi } from "../apiClient"

interface AddToCartParams {
  request: AddToCartRequest
}

const useCart = () => {
  const addToCartMutation = useMutation<
    AddToCartResponse,
    Error,
    AddToCartParams
  >({
    mutationKey: ["addToCart"],
    mutationFn: async ({ request }) => {
      const response = await publicApi.post<AddToCartResponse>(
        `/skipass/app/cart/addtocart?cultureName=${i18n.language}`,
        request
      )

      if (!response.data.Success) {
        throw new Error(response.data.ErrorMessage || "Unknown error occurred")
      }

      return response.data
    },
    retry: 2,
  })

  const { mutate, isPending, error, isSuccess } = addToCartMutation

  return {
    addToCart: mutate,
    isLoading: isPending,
    error,
    isSuccess,
  }
}

export default useCart
